import { CHANGELOG_TTL_MS } from '../../changelog/changelog.ts'

export const shouldHighlightChangelog = (
  newestPublishedAtMs: number,
  nowMs = Date.now()
) => {
  if (newestPublishedAtMs <= 0) return false
  return nowMs - newestPublishedAtMs < CHANGELOG_TTL_MS
}

export const toMs = (iso: string): number => {
  const ms = Date.parse(iso)
  return Number.isFinite(ms) ? ms : 0
}